export interface IhistoryCard {
    operatorRole: OperatorRoleType;
    title: string;
    operateTime: string;
    content: string[];
}

enum OperatorRoleType {
    PLATFORM = 1,
    BUYER = 2,
    SELLER = 3,
}

export const imgUrlMap = {
    [OperatorRoleType.PLATFORM]:
        'https://s3plus.meituan.net/v1/mss_0e4451a82e1d428f9fc3b99c0b3ebf15/pic-manager/c7cc56d25ad9677d/platform.png',
    [OperatorRoleType.BUYER]:
        'https://s3plus.meituan.net/v1/mss_0e4451a82e1d428f9fc3b99c0b3ebf15/pic-manager/6c85929f4c7ba083/buyer.png',
    [OperatorRoleType.SELLER]:
        'https://s3plus.meituan.net/v1/mss_0e4451a82e1d428f9fc3b99c0b3ebf15/pic-manager/4f6384a380f904bd/seller.png',
};

export interface IProivderContact {
    sellerName: string;
    sellerPhone: string;
    sellerAddress: string;
}

export interface IUpdateProviderContactReq extends IProivderContact {
    providerId: string;
}
